import { Box, ButtonBase, Stack, Typography } from '@mui/material'
import type { ReactElement } from 'react'

import { sidebarButtonRootNoChevronSx } from '../sidebarButtonStyles'

interface Props {
  icon: ReactElement
  label: string
  onClick: () => void
  disabled?: boolean
  testid?: string
}

export function SidebarRowButton(props: Props) {
  const { icon, label, onClick, disabled = false, testid } = props

  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      data-trackid={testid}
      data-testid={testid}
      sx={sidebarButtonRootNoChevronSx}
    >
      <Stack direction="row" alignItems="center" width="100%">
        <Box
          minWidth={20}
          mr={2.25}
          display="flex"
          alignItems="center"
          justifyContent="center"
          color={disabled ? 'text.disabled' : 'text.primary'}
        >
          {icon}
        </Box>
        <Typography
          variant="body1"
          fontWeight={500}
          color={disabled ? 'text.disabled' : 'text.primary'}
          align="left"
          noWrap
          flex={1}
        >
          {label}
        </Typography>
      </Stack>
    </ButtonBase>
  )
}
